import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditNonTeachingStaffLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'EditNonTeachingStaff' */ './components/EditNonTeachingStaff'
		)
);

export default (store) => {
	return {
		path: 'nonteaching-staff/edit/:id',
		element: (
			<AsyncLoading
				component={
					<EditNonTeachingStaffLazy featureFlag="FeatureFlag:TransportModule" />
				}
			/>
		),
	};
};
